import o from "styled-components";
import { Text as i } from "./atoms-v243.js";
import { breakpoints as n } from "./atoms-v2125.js";
const p = o.div`
  align-items: center;
  border-bottom: ${({ $colorTheme: t, $isLastInList: e, theme: r }) => e ? "none" : `1px solid ${r.get(`tokens.border.${t}.light`)}`};
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-bottom: ${({ $isLastInList: t }) => t ? "0" : "16px"};
  width: 100%;

  @media ${n.medium} {
    padding-bottom: ${({ $isLastInList: t }) => t ? "0" : "12px"};
  }
`, $ = o.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`, a = o(i)`
  color: ${({ $colorTheme: t, theme: e }) => e.get(`tokens.text.${t}.primary`)};
  ${({ theme: t }) => t.get("tokens.body.productive").toJS()}

  @media ${n.medium} {
    ${({ theme: t }) => t.get("tokens.body.expressive").toJS()}
  }
`, c = o(i)`
  color: ${({ $colorTheme: t, theme: e }) => e.get(`tokens.text.${t}.primary`)};
  ${({ theme: t }) => t.get("tokens.heading.compact-01").toJS()}

  @media ${n.medium} {
    ${({ theme: t }) => t.get("tokens.heading.02").toJS()}
  }
`, g = o(i)`
  color: ${({ $colorTheme: t, theme: e }) => e.get(`tokens.text.${t}.tertiary`)};
  ${({ theme: t }) => t.get("tokens.helper.productive").toJS()}

  @media ${n.medium} {
    ${({ theme: t }) => t.get("tokens.body.productive").toJS()}
  }
`, l = o(i)`
  color: ${({ $colorTheme: t, theme: e }) => e.get(`tokens.text.${t}.tertiary`)};
  ${({ theme: t }) => t.get("tokens.helper.productive").toJS()}
`;
export {
  p as Container,
  a as Label,
  $ as Row,
  g as Time,
  l as Type,
  c as Value
};
